import { combineReducers } from "redux";
import appReducer from "./AppReducer";
import zoomReducer from "./ZoomReducer";
import seekerReducer from "./SeekerReducer";
import verificationStatusReducer from "./VerificationStatusReducer";
import registrationDataSlice from "./registrationReducer"

const rootReducer = combineReducers({
  appReducer,
  zoomReducer,
  seekerReducer,
  verificationStatusReducer,
  registrationDataSlice
  // Add more reducers as needed
});

export default rootReducer;
